export const itemAnimationVariants = {
  show: {
    transform: "translateX(0em)",
    opacity: 1,
    transition: { delay: 0.05, duration: 0.2 }
  },
  hide: {
    transform: "translateX(5em)",
    opacity: 0,
    transition: { delay: 0.05, duration: 0.2 }
  }
}
